import React from 'react';
import { Badge } from '../ui/Badge';
import { Checkbox } from '../ui/Checkbox';
import { User, Eye } from 'lucide-react';
import * as Tooltip from '@radix-ui/react-tooltip';
import { FindingActions } from './FindingActions';
import { AssigneeSelect } from './AssigneeSelect';
import { Link } from 'react-router-dom';
import { Membership } from 'api-client';

interface Finding {
  id: string;
  title: string;
  severity: 'critical' | 'high' | 'medium' | 'low';
  status: 'open' | 'resolved' | 'in_progress' | 'false_positive' | 'duplicate';
  asset: string;
  discoveredAt: string;
  assignee?: {
    id: string;
    name: string;
    role: string;
    avatar?: string;
  };
  description: string;
}

interface FindingsTableRowProps {
  finding: any;
  isSelected: boolean;
  onSelect: (id: string, selected: boolean) => void;
  onAssign: (id: string, assigneeId: string) => void;
  onAction: (id: string, action: string) => void;
  assignees: Array<Membership>;
}

export const FindingsTableRow: React.FC<FindingsTableRowProps> = ({
  finding,
  isSelected,
  onSelect,
  onAssign,
  onAction,
  assignees,
}) => {
  return (
    <tr className="group hover:bg-gray-800/30 transition-colors">
      <td className="px-6 py-4">
        <Checkbox
          checked={isSelected}
          onCheckedChange={(checked) => onSelect(finding.id, !!checked)}
        />
      </td>
      <td className="px-6 py-4">
        <Link to={`/findings/${finding.id}`} className="text-sm font-medium text-white">
          <div className="text-sm font-medium text-white">{finding.title}</div></Link>


        <div className="text-xs text-gray-400 mt-1 truncate max-w-[300px]" title={finding.overview}>
          {finding.overview}
        </div>
      </td>
      <td className="px-6 py-4">
        <Badge variant={finding.severity}>{finding.severity.toUpperCase()}</Badge>
      </td>
      <td className="px-6 py-4">
        <Badge variant={finding.status}>{finding.status.replace('_', ' ').toUpperCase()}</Badge>
      </td>
      <td className="px-6 py-4">
        <div className="text-sm text-gray-300">{finding.assetName}</div>
      </td>
      <td className="px-6 py-4">
        <Tooltip.Provider>
          <Tooltip.Root>
            <Tooltip.Trigger asChild>
              <div className="text-sm text-gray-300">
                {new Date(finding.createdAt).toLocaleDateString()}
              </div>
            </Tooltip.Trigger>
            <Tooltip.Portal>
              <Tooltip.Content
                className="bg-[#1A1F2E] text-white text-xs px-2 py-1 rounded shadow-lg"
                sideOffset={5}
              >
                {new Date(finding.createdAt).toLocaleString()}
                <Tooltip.Arrow className="fill-[#1A1F2E]" />
              </Tooltip.Content>
            </Tooltip.Portal>
          </Tooltip.Root>
        </Tooltip.Provider>
      </td>
      <td className="px-6 py-4">
        <AssigneeSelect
          assignees={assignees}
          onAssign={(assigneeId) => onAssign(finding.id, assigneeId)}
          currentAssigneeId={finding.assignee?.id}
        />
      </td>
      <td className="px-6 py-4">
        <div className="flex items-center gap-2">
          <Link
            to={`/findings/${finding.id}`}
            className="bg-[#1A1F2E] text-white"
          >
            <Eye className="h-4 w-4" />
          </Link>
          <FindingActions
            onAction={(action) => onAction(finding.id, action)}
            // disabled={finding.status === 'resolved'}
            disabled
          />
        </div>

      </td>
    </tr>
  );
};